import { makeStyles } from '@material-ui/core'
import React from 'react'

/**
 * Content for assistive technology only.
 *
 * Extracted because the same clip-rect block was written out in
 * SupportSlaPolicies and again in IdleWarningOverlay — whose own comment
 * acknowledged it was a copy. An accessibility helper duplicated per screen
 * drifts, and the copy that drifts is the one nobody is looking at.
 *
 * `clip`/`clip-path` rather than `display: none` or `visibility: hidden`: those
 * two remove the element from the accessibility tree as well as the page, which
 * is the opposite of what this is for.
 */
const useStyles = makeStyles({
  visuallyHidden: {
    position: 'absolute',
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    border: 0
  }
})

interface VisuallyHiddenProps {
  children: React.ReactNode
  /** Announce changes to this content as it updates (spinners, counts). */
  live?: 'polite' | 'assertive'
}

export default function VisuallyHidden({
  children,
  live
}: VisuallyHiddenProps) {
  const classes = useStyles()

  return (
    <span
      className={classes.visuallyHidden}
      role={live ? 'status' : undefined}
      aria-live={live}>
      {children}
    </span>
  )
}
